// 管理者用：シフト提出期間設定ページ（/admin/schedule）

import React, { useEffect, useState } from "react";
import { getRequest, postRequest, putRequest, deleteRequest } from "../../apiWrapper";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";
import { formatDate, formatDateTimeLocal } from "../../utils/formatDate";

const AdminShiftEntryWindows = () => {
  const [windows, setWindows] = useState([]);
  const [formData, setFormData] = useState({
    start_date: "",
    end_date: "",
    deadline: "",
  });
  const [editingId, setEditingId] = useState(null);

  const fetchWindows = async () => {
    try {
      const res = await getRequest("shiftEntryWindows");
      setWindows(res.windows);
    } catch (err) {
      console.error("取得エラー", err);
    }
  };

  useEffect(() => {
    fetchWindows();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    const { start_date, end_date, deadline } = formData;
    if (!start_date || !end_date || !deadline) {
      toast.error("全ての項目を入力してください");
      return;
    }
    if (new Date(end_date) < new Date(start_date)) {
      toast.error("終了日は開始日以降の日付を指定してください");
      return;
    }
    try {
      let response;
      if (editingId) {
        console.log("update shift entry");
        response = await putRequest(`shiftEntryWindows/${editingId}`, formData);
      } else {
        console.log("post shift entry");
        response = await postRequest("shiftEntryWindows", formData);
      }
      if (response.ok) {
        toast.success(editingId ? "更新しました" : "登録しました");
        fetchWindows();
        setFormData({ start_date: "", end_date: "", deadline: "" });
        setEditingId(null);
      } else {
        const data = await response.json();
        toast.error(data.error || "送信に失敗しました");
      }
    } catch (err) {
      console.error("送信エラー", err);
      toast.error("送信に失敗しました");
    }
  };

  const handleEdit = (win) => {
    setFormData({
        start_date: formatDate(win.start_date),
        end_date: formatDate(win.end_date),
        deadline: formatDateTimeLocal(win.deadline),
    });
    setEditingId(win.id);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("本当に削除しますか？")) return;
    try {
      const response = await deleteRequest(`shiftEntryWindows/${id}`);
      if (response.ok) {
        toast.success("削除しました");
        fetchWindows();
      } else {
        const data = await response.json();
        toast.error(data.error || "削除に失敗しました");
      }
    } catch (err) {
      console.error("削除エラー", err);
      toast.error("削除に失敗しました");
    }
  };

  return (
    <div className="p-6 pt-20 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">シフト提出期間の管理</h1>

      <div className="bg-white p-4 rounded shadow mb-6">
        <h2 className="text-lg font-semibold mb-2">{editingId ? "編集" : "新規追加"}</h2>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">開始日</label>
            <input type="date" name="start_date" value={formData.start_date} onChange={handleChange} className="border p-2 rounded w-full" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">終了日</label>
            <input type="date" name="end_date" value={formData.end_date} onChange={handleChange} className="border p-2 rounded w-full" />
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium mb-1">入力締切日時</label>
            <input type="datetime-local" name="deadline" value={formData.deadline} onChange={handleChange} className="border p-2 rounded w-full" />
          </div>
        </div>
        <button onClick={handleSubmit} className="mt-4 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600">
          {editingId ? "更新" : "追加"}
        </button>
      </div>

      <div className="bg-white p-4 rounded shadow">
        <h2 className="text-lg font-semibold mb-2">既存の期間</h2>
        <table className="w-full border">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 border">開始日</th>
              <th className="p-2 border">終了日</th>
              <th className="p-2 border">締切</th>
              <th className="p-2 border">操作</th>
            </tr>
          </thead>
          <tbody>
            {windows.map((win) => (
              <tr key={win.id} className="border">
                <td className="p-2 border">{formatDate(win.start_date)}</td>
                <td className="p-2 border">{formatDate(win.end_date)}</td>
                <td className="p-2 border">{formatDateTimeLocal(win.deadline)}</td>
                <td className="p-2 border flex gap-2">
                  <button onClick={() => handleEdit(win)} className="text-blue-600 hover:text-blue-800">
                    <FaEdit />
                  </button>
                  <button onClick={() => handleDelete(win.id)} className="text-red-600 hover:text-red-800">
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminShiftEntryWindows;